define('BluePoint.AddressBookSearch.AddressBookSearch'
,   [
		'BluePoint.AddressBookSearch.AddressBookSearch.View'
	]
,   function (
		AddressBookSearchView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			
			if(layout)
			{
				layout.addChildView('AddressBook.Search', function() { 
					return new AddressBookSearchView({ container: container });
				});
			}    
		}
	};
});
